/**
 * Get the Content Settings Group Ids from the gradeGroup list
 *
 * @param gradeRanges string[] grade groups list
 * @param contentSettingsGroups {id, grade_minimum, grade_maximum}[] Content Settings Group list
 * @returns string[]
 */
const getIdsOfContentSettingsGroups = ({
  gradeRanges,
  contentSettingsGroups,
}) => {
  const consetGroups = gradeRanges?.map((gradeGroup) => {
    const [gradeMin, gradeMax] =
      (gradeGroup && gradeGroup.split("-").map(Number)) ?? [];
    return contentSettingsGroups?.find(
      ({ grade_minimum: gradeMinimum, grade_maximum: gradeMaximum }) =>
        gradeMinimum === gradeMin &&
        (gradeMaximum === gradeMax ||
          (gradeMax === undefined && gradeMaximum === gradeMinimum)),
    )?.id;
  });
  return consetGroups?.filter((consetGroup) => consetGroup !== undefined) ?? [];
};

export default getIdsOfContentSettingsGroups;
